import { defineMessages } from 'react-intl';

export const servicePlansMessages = defineMessages({
    servicePlans: {
        id: 'service-plans',
        defaultMessage: 'Service plans',
    },
    plans: {
        id: 'plans',
        defaultMessage: 'Plans',
    },
    plan: {
        id: 'plan',
        defaultMessage: 'Plan',
    },
    category: {
        id: 'category',
        defaultMessage: 'Category',
    },
    isActive: {
        id: 'is-active',
        defaultMessage: 'Is active',
    },
    code: {
        id: 'code',
        defaultMessage: 'Code',
    },
    externalServicePlan: {
        id: 'external-service-plan',
        defaultMessage: 'External service plan',
    },
    createServicePlanSuccess: {
        id: 'create-service-plan-success',
        defaultMessage: 'Service plan created',
    },
    createServicePlanSuccessDescription: {
        id: 'create-service-plan-success-description',
        defaultMessage: 'Service plan {entry} has been successfully created.',
    },
    addServicePlanSubtitle: {
        id: 'add-service-plan-subtitle',
        defaultMessage: 'Create a new service plan',
    },
    invoiceName: {
        id: 'invoice-name',
        defaultMessage: 'Invoice name',
    },
    deleteServicePlan: {
        id: 'delete-service-plan',
        defaultMessage: 'Delete service plan',
    },
    deleteServicePlanSuccess: {
        id: 'delete-service-plan-success',
        defaultMessage: 'Service plan deleted',
    },
    deleteServicePlanSuccessDescription: {
        id: 'delete-service-plan-success-description',
        defaultMessage: 'The service plan has been successfully deleted.',
    },
    confirmDeleteServicePlan: {
        id: 'confirm-delete-service-plan',
        defaultMessage: 'Are you sure you want to delete this service plan? This action cannot be undone.',
    },
    deleteServicePlanSubtitle: {
        id: 'delete-service-plan-subtitle',
        defaultMessage: 'Permanently delete service plan {entity}',
    },
    editServicePlanSubtitle: {
        id: 'edit-service-plan-subtitle',
        defaultMessage: 'Edit service plan {entity}',
    },
    updateServicePlanSuccess: {
        id: 'update-service-plan-success',
        defaultMessage: 'Service plan updated',
    },
    updateServicePlanSuccessDescription: {
        id: 'update-service-plan-success-description',
        defaultMessage: 'Service plan {entity} has been successfully updated.',
    },
    backToAllServicePlans: {
        id: 'back-to-all-service-plans',
        defaultMessage: 'Back to all service plans',
    },
    servicePlanDashboard: {
        id: 'service-plan-dashboard',
        defaultMessage: 'Service plan dashboard',
    },
    tenant: {
        id: 'tenant',
        defaultMessage: 'Tenant',
    },
    currentTermsValidFrom: {
        id: 'current-terms-valid-from',
        defaultMessage: 'Current terms valid from',
    },
    currentTermsValidTo: {
        id: 'current-terms-valid-to',
        defaultMessage: 'Current terms valid to',
    },
    unpaidGraceDays: {
        id: 'unpaid-grace-days',
        defaultMessage: 'Unpaid grace days',
    },
    lockWarningDays: {
        id: 'lock-warning-days',
        defaultMessage: 'Lock warning days',
    },
    lockGraceDays: {
        id: 'lock-grace-days',
        defaultMessage: 'Lock grace days',
    },
    stopWarningDays: {
        id: 'stop-warning-days',
        defaultMessage: 'Stop warning days',
    },
    stopGraceDays: {
        id: 'stop-grace-days',
        defaultMessage: 'Stop grace days',
    },
    servicePlan: {
        id: 'service-plan',
        defaultMessage: 'Service plan',
    },
    version: {
        id: 'version',
        defaultMessage: 'Version',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    searchServicePlan: {
        id: 'search-service-plan',
        defaultMessage: 'Search for service plan',
    },
    noServicePlan: {
        id: 'no-service-plan',
        defaultMessage: 'No service plan',
    },
    noServicePlanFound: {
        id: 'no-service-plan-found',
        defaultMessage: 'No service plan found',
    },
    deactivateServicePlanSuccess: {
        id: 'deactivate-service-plan-success',
        defaultMessage: 'Service plan deactivated',
    },
    deactivateServicePlanSuccessDescription: {
        id: 'deactivate-service-plan-success-description',
        defaultMessage: 'The service plan was deactivated successfully.',
    },
    deactivateServicePlan: {
        id: 'deactivate-service-plan',
        defaultMessage: 'Deactivate service plan',
    },
    deactivateServicePlanSubtitle: {
        id: 'deactivate-service-plan-subtitle',
        defaultMessage: 'Deactivate service plan {name}',
    },
    confirmDeactivateServicePlan: {
        id: 'confirm-deactivate-service-plan',
        defaultMessage: 'Are you sure you want to deactivate this service plan? This action cannot be undone.',
    },
    deactivate: {
        id: 'deactivate',
        defaultMessage: 'Deactivate',
    },
    activateServicePlanSuccess: {
        id: 'activate-service-plan-success',
        defaultMessage: 'Service plan activated',
    },
    activateServicePlanSuccessDescription: {
        id: 'activate-service-plan-success-description',
        defaultMessage: 'The service plan was activated successfully.',
    },
    activateServicePlan: {
        id: 'activate-service-plan',
        defaultMessage: 'Activate service plan',
    },
    activateServicePlanSubtitle: {
        id: 'activate-service-plan-subtitle',
        defaultMessage: 'Activate service plan {name}',
    },
    confirmActivateServicePlan: {
        id: 'confirm-activate-service-plan',
        defaultMessage: 'Are you sure you want to activate this service plan? This action cannot be undone.',
    },
    activate: {
        id: 'activate',
        defaultMessage: 'Activate',
    },
    noBillingPricingPolicyError: {
        id: 'custom-error:service_plan_item_without_billing_or_pricing_policy',
        defaultMessage:
            'All service plan items must have an active billing and pricing policy before the plan can be activated!',
    },
    uniqueCodeError: {
        id: 'custom-error:code',
        defaultMessage: 'Service plan item with this code already exists.',
    },
    missingServicePlanTermError: {
        id: 'custom-error:missing_current_service_plan_terms',
        defaultMessage: 'Service plan does not have currently active terms!',
    },
    missingItemsServicePlanError: {
        id: 'custom-error:activate_service_plan_without_items',
        defaultMessage: 'Service plan cannot be activated because it has no service plan items!',
    },
    servicePlanSubscriptionError: {
        id: 'custom-error:delete_service_plan_with_subscriptions',
        defaultMessage: 'Cannot delete service plan which has related subscriptions!',
    },
    deleteServicePlanError: {
        id: 'custom-error:delete_active_service_plan',
        defaultMessage: 'Cannot delete service plan which is active!',
    },
    activationRequiresActiveTermsError: {
        id: 'custom-error:activate_service_plan_without_active_items',
        defaultMessage: 'Service plan activation requires at least one active service plan item!',
    },
});
